export const goToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: "instant", block: "start" });
}
